import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Preloader from "../../components/Preloader";
import { DocumentServices } from "../../services/DocumentService";
import { TipoPostulacionService } from "../../services/TipoPostulacionService";
import { ClienteService } from "../../services/ClienteService";
import { Search } from "lucide-react";
import { PostulanteService } from "../../services/PostulanteService";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";

const NuevoPostulante = () => {
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [form, setForm] = useState({
        tipoPostulacion: "",
        nombres: "",
        tipoDocumento: "",
        numeroDocumento: "",
        telefono: "",
        email: "",
        edad: "",
    });
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [tiposPostulacion, setTiposPostulacion] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const cargarTipoDocumentos = async () => {
            try {
                const response = await DocumentServices.getDocuments(token);
                const documentosFiltrados = (response || []).filter(
                    (doc) => doc.description && !doc.description.toUpperCase().includes("RUC")
                );
                setTiposDocumentos(documentosFiltrados);
            } catch (error) {
                console.error("Error al cargar tipos de Documentos:", error);
            }
        };

        const cargarTipoPostulacion = async () => {
            try {
                const tipos = await TipoPostulacionService.getTipoPostulacion(token);
                setTiposPostulacion(tipos || []);
            } catch (error) {
                console.error("Error al cargar tipos de Documentos:", error);
            }
        };

        cargarTipoDocumentos();
        cargarTipoPostulacion();
    }, [token]);


    const handleBackToList = () => {
        navigate("/admin/reclutamiento"); // ajusta según tu ruta de listado
    };

    const buscarCliente = async () => {
        try {
            if (!form.numeroDocumento || form.numeroDocumento.trim() === "") {
                setErrors((prev) => ({
                    ...prev,
                    numeroDocumento: "Ingrese un número válido",
                }));
                return;
            }

            const cliente = await ClienteService.buscarPorDocumento({
                token,
                tipoDocumento: form.tipoDocumento,
                numeroDocumento: form.numeroDocumento,
            });

            if (form.tipoDocumento === "1" && cliente) {
                setForm((prev) => ({
                    ...prev,
                    nombres: cliente.nombres + " " + cliente.apellido_paterno + " " + cliente.apellido_materno || "",

                }));
            }

            setErrors((prev) => ({
                ...prev,
                numeroDocumento: null,
            }));
        } catch (err) {
            const mensaje = err.response?.data?.error || err.message || "Error al consultar el servicio";
            setErrors((prev) => ({
                ...prev,
                numeroDocumento: mensaje,
            }));
        }
    }

    const validateNumericInput = (value) => {
        return value.replace(/\D/g, "");
    };


    const handleNumericChange = (e) => {
        const { name, value } = e.target;
        const numericValue = validateNumericInput(value);
        setForm((prev) => ({
            ...prev,
            [name]: numericValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errores = validarFormulario();

        if (Object.keys(errores).length > 0) {
            setErrors(errores);
            return;
        }
        setLoading(true);
        try {
            const datosEnvio = { ...form, correo: form.email };
            const response = await PostulanteService.registrarPostulante(token, datosEnvio);

            if (response.success) {
                toast.success(response.message);
                setForm({
                    tipoPostulacion: "",
                    nombres: "",
                    tipoDocumento: "",
                    numeroDocumento: "",
                    telefono: "",
                    email: "",
                    edad: "",
                });
                navigate('/admin/reclutamiento');
            } else if (response.message === 'Ya existe un postulante con ese documento') {
                setErrors({ numeroDocumento: response.message });
            } else {
                setError(response.message || 'No se pudo registrar la postulación');
            }

        } catch (err) {
            setError("Error al registrar el postulante.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "edad") {
            // Solo permitir números
            if (!/^\d*$/.test(value)) return;
        }

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validarFormulario = () => {
        const nuevosErrores = {};

        if (!form.tipoPostulacion) {
            nuevosErrores.tipoPostulacion = "El tipo de postulación es obligatorio";
        }

        if (form.numeroDocumento && !/^\d+$/.test(form.numeroDocumento)) {
            nuevosErrores.numeroDocumento = "Ingrese un número de documento válido";
        }

        if (!form.nombres || form.nombres.trim() === "") {
            nuevosErrores.nombres = "El nombre es obligatorio";
        }

        if (!form.telefono && !/^\d{7,15}$/.test(form.telefono)) {
            nuevosErrores.telefono = "Ingrese un teléfono válido";
        }

        if (form.email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            if (!emailRegex.test(form.email)) {
                nuevosErrores.email = "Correo electrónico inválido";
            }
        }

        if (form.edad && !/^\d+$/.test(form.edad)) {
            nuevosErrores.edad = "Ingrese una edad válida (solo números)";
        } else if (Number.parseInt(form.edad) < 18 || Number.parseInt(form.edad) > 100) {
            nuevosErrores.edad = "La edad debe estar entre 18 y 100 años";
        }

        return nuevosErrores;
    };

    return (
        <div className="ventas-admin-content">
            {loading && <Preloader />}
            <div className="breadcrumb-container">
                <button type="button" className="breadcrumb-link" onClick={handleBackToList}>
                    ← Listado de Postulantes
                </button>
                <span className="breadcrumb-current"> / Registrar Postulante</span>
            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="dashboard-card nuevo-producto-card">
                <span className="nueva-venta-title"> Registrar Postulante</span>
                <form className="nuevo-producto-form" onSubmit={handleSubmit}>
                    <div className="form-section">
                        <h3 className="section-title">Datos del Postulante</h3>
                        <div className="form-grid">
                            <div className="">
                                <label htmlFor="tipoPostulacion">Tipo de Postulación*</label>
                                <select
                                    name="tipoPostulacion"
                                    value={form.tipoPostulacion}
                                    onChange={handleChange}
                                >
                                    <option value="">Selecciona tipo de postulación</option>
                                    {tiposPostulacion.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>
                                            {tipo.descripcion}
                                        </option>
                                    ))}
                                </select>
                                {errors.tipoPostulacion && (
                                    <span className="error">{errors.tipoPostulacion}</span>
                                )}
                            </div>
                            <div className="">
                                <label htmlFor="tipoDocumento">Tipo de Documento </label>
                                <select
                                    name="tipoDocumento"
                                    value={form.tipoDocumento}
                                    onChange={handleChange}

                                >
                                    <option value="">Selecciona tipo de documento</option>
                                    {tiposDocumentos.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>
                                            {tipo.description}
                                        </option>
                                    ))}
                                </select>
                                {errors.tipoDocumento && (
                                    <span className="error">{errors.tipoDocumento}</span>
                                )}
                            </div>
                        </div>
                        <div className="form-grid">
                            <div className="">
                                <label htmlFor="numeroDocumento">Número de Documento </label>
                                <div className="input-with-button">
                                    <input
                                        type="text"
                                        name="numeroDocumento"
                                        value={form.numeroDocumento}
                                        onChange={handleNumericChange}
                                        placeholder="Solo números"
                                    />
                                    {(form.tipoDocumento === "1") && (
                                        <button
                                            type="button"
                                            className="search-btn-documento"
                                            title="Buscar cliente"
                                            onClick={buscarCliente}
                                        >
                                            <Search size={20} color="#555" />
                                        </button>
                                    )}
                                </div>
                                {errors.numeroDocumento && (
                                    <span className="error">{errors.numeroDocumento}</span>
                                )}
                            </div>
                            <div className="">
                                <label htmlFor="nombres">Nombres*</label>
                                <input
                                    type="text"
                                    name="nombres"
                                    value={form.nombres}
                                    onChange={handleChange}
                                    placeholder="Nombres del Postulante"
                                />
                                {errors.nombres && <span className="error">{errors.nombres}</span>}
                            </div>
                        </div>
                        <div className="form-grid">
                            <div className="">
                                <label htmlFor="telefono">Teléfono* </label>
                                <input
                                    type="text"
                                    name="telefono"
                                    value={form.telefono}
                                    onChange={handleChange}
                                    placeholder="Teléfono"
                                />
                                {errors.telefono && (
                                    <span className="error">{errors.telefono}</span>
                                )}
                            </div>
                            <div className="">
                                <label htmlFor="email">Correo Electrónico</label>
                                <input
                                    type="text"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    placeholder="Ingresa un Correo Electrónico"
                                />
                                {errors.email && (
                                    <span className="error">{errors.email}</span>
                                )}
                            </div>
                        </div>
                        <div className="form-grid">
                            <div className="">
                                <label htmlFor="edad">Edad </label>
                                <input
                                    type="text"
                                    name="edad"
                                    value={form.edad}
                                    onChange={handleChange}
                                    placeholder="Edad del Postulante"
                                />
                                {errors.edad && (
                                    <span className="error">{errors.edad}</span>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className="form-actions">

                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Registrando..." : " Registrar Postulante"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NuevoPostulante;
